import { View } from 'react-native';
import { Catcher } from 'system/catcher';
import { articleModuleQuery, useModule } from 'system/structure-modules';
import { useNotifyHostAboutDimensionOnLayoutHandler } from 'util/iframe-messaging';

export default function ArticleTeaserScreen() {
    const onLayout = useNotifyHostAboutDimensionOnLayoutHandler();
    const { ArticleTeaser } = useModule(articleModuleQuery);

    return (
        <View onLayout={onLayout}>
            <Catcher>
                <ArticleTeaser />
            </Catcher>
        </View>
    );
}
